import './Header.scss'
import Link from './elements/link'
import Logo from './elements/logo'
import LanguageSwitch from './elements/languageSwitch'
import Navigation from './Navigation'
import { useState, useContext, useEffect } from 'react'
import GlobalContext from '../global'
import useScrollNav from '../helpers/useScrollNav'

export default ({ alwaysFilled, alwaysShow }) => {
  const global = useContext(GlobalContext)
  const [navOpen, changeNavOpen] = useState(false)
  if (navOpen) {
    alwaysShow = true
  }
  let { isBelowFold, show } = useScrollNav(alwaysShow)
  const filled = navOpen || alwaysFilled ? true : isBelowFold
  useEffect(() => {
    navOpen ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'initial')
  })
  return (
    <>
      <div
        className={`header ${filled ? 'filled' : 'transparent'} ${show ? 'show' : 'hide'} default-${
          global.data.default_color
        }`}
      >
        <Link type="internal" route="/">
          <a className="logo">
            <Logo />
          </a>
        </Link>
        <div className="header-interactive">
          <LanguageSwitch />
          {global.data.body.length > 0 && (
            <div className="burger" onClick={() => changeNavOpen(!navOpen)}>
              {navOpen && (
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
                  <path
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                    d="M.3535.3534L20.8535 20.8534M.3535 20.8534L20.8535.3534"
                    transform="translate(1)"
                  />
                </svg>
              )}
              {!navOpen && (
                <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 28 28">
                  <rect fill="#fff" x="0" y="3" width="28" height="3" />
                  <rect fill="#fff" x="0" y="12" width="28" height="3" />
                  <rect fill="#fff" x="0" y="21" width="28" height="3" />
                </svg>
              )}
            </div>
          )}
        </div>
      </div>
      {navOpen && <Navigation />}
    </>
  )
}
